<template>
    <div class="drug-list">
        <div class="border-title font-s24 c33">药品信息</div>
           <div class="content">
          <div class="clearfix">
                <div class="dragList" v-for="(val,index) in list" :key="index" @click="dragListLink(index,val.title)">
                    <div class="dragImg">
                        <img :src="val.src">
                    </div>
                    <div class="imgTitle">{{val.title}}</div>
                    <div class="drugTxt">
                       <div>{{val.specifications}}</div>
                       <div>{{val.content}}</div>
                    </div>
                </div>
            </div>
         </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            list:[
                {src:require("../../assets/image/drug/1.png"),title:'罗红霉素片',specifications:'规格:75mg*121',content:' 1、适用于敏感菌株引起的下列感染：上呼吸道感染，下呼吸道感染，耳鼻喉感染...'},
                {src:require("../../assets/image/drug/2.png"),title:'贞芪扶正颗粒',specifications:'规格:15g*10袋',content:' 有提高人体免疫功能，保护骨髓和肾上腺皮质功能；用于各种疾病引起的虚损...'},
                {src:require("../../assets/image/drug/3.png"),title:'复方梨汁润肺茶',specifications:'规格:5g*9块',content:' 健脾润肺，止咳化痰。用于脾肺两虚证所致咳嗽，咳痰，气短。'},
                {src:require("../../assets/image/drug/4.png"),title:'注射用果糖二磷酸钠（艾欣利尔）',specifications:'规格:5g*1支/盒',content:'慢性呼吸衰竭,酒精中毒,心绞痛,营养不良,心律失常,心肌缺血,休克,急性心肌梗死'},
                {src:require("../../assets/image/drug/5.png"),title:'注射用阿奇霉素（瑞奇）',specifications:'规格:0.25g*10支/盒',content:' 本品适用于敏感致病菌株所引起的下列感染：1.由肺炎衣原体、流感嗜血'},
                {src:require("../../assets/image/drug/6.png"),title:'参志胶囊',specifications:'规格:60粒',content:' 益气养血，清热祛痰，醒神益智。用于痰淤藴热，阻闭心窍所致小儿智能低下...'},
                {src:require("../../assets/image/drug/7.png"),title:'癫痫平片',specifications:'规格:100片',content:' 豁痰开窍，平肝清热，熄风定痫。用于风痰闭阻所致癫痫。'},
                {src:require("../../assets/image/drug/8.png"),title:'蒲郁胶囊',specifications:'规格:20粒',content:' 清心化痰，疏肝解郁。用于肝郁化火之神经衰弱，症见失眠，多梦，心中烦热，易怒。'},
            ],
        }
    },
    methods:{
        dragListLink(index,title){
           this.$router.push({ path: "/drug/drugDetail", query: { id: index+1,title:title } });
        }
    }
};
</script>

<style lang="scss">
.drug-list{

.dragList {
  width: 280px;
  float: left;
  margin-top: 20px;
  margin-right: 20px;
//   background: #f4f4f4;
  border: 1px #dddddd solid;
  padding: 20px 20px 30px;
  cursor: pointer;
}
.dragList:nth-child(3n) {
  margin-right: 0px;
}
 .dragImg {
  height: 210px;
  text-align: center;
}
 .dragImg img{
  line-height: 1;
  
}
.dragImg img:hover {
  transform: scale(1.1);
  transition: 1s;
}
 .imgTitle {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  padding-bottom: 20px;
  line-height: 1;
}
.drugTxt {
  font-size: 14px;
  color: #666;
  text-align: justify;
text-justify: distribute-all-lines;
line-height: 1.2
}
}
</style>
